import type { DockMode } from "@/types/assistant.types";

// Spec (dock flutuante) — mapa modo → apresentação do painel. Puro/testável; mantém o index.tsx enxuto.
// right/bottom são ANCORADOS (empurram o <main> via reflow, com ResizeHandle); floating é SOBREPOSTO.
const SHELL: Record<DockMode, string> = {
  right: "inset-y-0 right-0 w-full border-l lg:w-[var(--dock-size)]",
  bottom: "inset-x-0 bottom-0 h-[70vh] border-t lg:left-[232px] lg:h-[var(--dock-size)]",
  floating:
    "bottom-4 right-4 w-[min(400px,calc(100vw-2rem))] h-[min(560px,calc(100vh-2rem))] rounded-xl border shadow-2xl",
};

export function dockShellClass(mode: DockMode): string {
  return SHELL[mode];
}

// Ancorado ⇒ usa ResizeHandle + reflow (empurra o conteúdo). Floating ⇒ sobreposto.
export function dockAnchored(mode: DockMode): mode is "right" | "bottom" {
  return mode !== "floating";
}
